import ForgotPasswordPage from '@gameday/react-components/components/ForgotPasswordPage'
import withWidth from '@material-ui/core/withWidth'
import { useEffect } from 'react'
import { forgotPasswordMsgSuccess } from 'shared/copy'

import routes from '../../../../constants/routes/routes'
import { buildPath } from '../../../../utils/common'

const ForgotPassword = ({
  forgotPassword,
  isSubmitPending,
  forgotPasswordMsg,
  eventLogo,
  landingPageLogo,
  orgLogo,
  formType,
  width,
  setForgotPasswordMsg,
  recaptcha,
  history,
  landingPageImage,
  bgGradientPrimaryColor,
  bgGradientSecondaryColor,
}) => {
  useEffect(() => {
    setForgotPasswordMsg(undefined)
  }, [])
  return (
    <ForgotPasswordPage
      title="Forgot Password"
      redirectLoginPath={buildPath(formType, routes.login.path, history)}
      logo={formType === 'event' ? eventLogo : orgLogo || landingPageLogo}
      formSuccess={forgotPasswordMsg === forgotPasswordMsgSuccess ? forgotPasswordMsg : ''}
      formError={forgotPasswordMsg && forgotPasswordMsg !== forgotPasswordMsgSuccess ? forgotPasswordMsg : ''}
      loadingForgotPassword={isSubmitPending}
      handleSubmit={(...args) => {
        recaptcha()
          .then(() => {
            forgotPassword(...args)
          })
          .catch(() => {
            setForgotPasswordMsg({
              type: 'ReCAPTCHA',
              message: 'Abnormal action detected',
            })
          })
      }}
      application={width !== 'xs' ? 'desktop' : 'mobile'}
      {...(landingPageImage && { backgroundImage: landingPageImage })}
      primaryColor={bgGradientPrimaryColor}
      secondaryColor={bgGradientSecondaryColor}
    />
  )
}

export default withWidth()(ForgotPassword)
